/* eslint-disable no-param-reassign, no-underscore-dangle */
import { HubConnectionBuilder, HttpTransportType, LogLevel } from '@microsoft/signalr';

class SocketConnection {
  constructor(options, eventSignalr) {
    this.options = options;
    this.services = {};
    this.authToken = options.authToken || null;
    this.eventSignalr = eventSignalr;
    if (options && options.services) {
      options.services.forEach(name => {
        this.createService(name);
      });
    }
  }

  bindMessage(service, message) {
    this.services[service].instance.on(message, response => {
      if (process.env.SIGNALR_DEBUG === 'enabled') {
        console.log(`Validate result of service ${service} ... ->`, response);
      }
      this.eventSignalr.$emit(`${service}-${message}`, response);
    });
  }

  createServiceMessages(service, messages) {
    messages.forEach(message => {
      if (!this.services[service].messages.find(messageItem => messageItem === message)) {
        this.services[service].messages.push(message);
        this.bindMessage(service, message);
      }
    });
  }

  async createServiceInstance(service, serviceOptions) {
    this.services[service] = {
      instance: null,
      messages: []
    };
    const { urlSignalr, skipNegotiation } = this.options;
    this.services[service].instance = new HubConnectionBuilder()
      .withUrl(
        `${urlSignalr}/${service}`,
        skipNegotiation
          ? {
              skipNegotiation,
              transport: HttpTransportType.WebSockets,
              ...serviceOptions
            }
          : serviceOptions
      )
      .configureLogging(
        process.env.NODE_ENV !== 'production' ? LogLevel.Information : LogLevel.Error
      )
      .build();

    this.services[service].instance.connection.onclose = async error => {
      if (process.env.NODE_ENV !== 'production') {
        console.log('Error signalr and reconnecting ... -> ', error);
      }
      this.createService(service, this.services[service].messages, true);
    };

    await this.services[service].instance.start();
  }

  createService(service, messages, restart = false) {
    const serviceOptions = {};
    if (this.authToken) {
      serviceOptions.accessTokenFactory = () => this.authToken;
    }

    if (restart) {
      try {
        this.createServiceInstance(service, serviceOptions);
      } catch (err) {
        throw new Error(err);
      }
      messages.forEach(messageEvent => {
        this.bindMessage(service, messageEvent);
      });
    } else if (this.services[service] && this.services[service].instance && messages) {
      this.createServiceMessages(service, messages);
    } else {
      try {
        this.createServiceInstance(service, serviceOptions);
      } catch (err) {
        throw new Error(err);
      }
      this.createServiceMessages(service, messages);
    }
  }

  updateAuthToken(newAuthToken) {
    if (this.authToken !== newAuthToken) {
      this.authToken = newAuthToken;
      Object.keys(this.services).forEach(serviceName => {
        this.createService(serviceName, this.services[serviceName].messages, true);
      });
    }
  }

  stop(service) {
    this.services[service].instance.stop();
  }
}
export default function plugin(Vue, options = {}) {
  if (options && options.constructor !== Object) throw new Error('Options must be a object');
  if (!options.urlSignalr) throw new Error('urlSignalr is required');

  if (process.env.NODE_ENV !== 'production' && plugin.installed) {
    return;
  }

  plugin.installed = true;

  const eventSignalr = new Vue();
  const Socket = new SocketConnection(options, eventSignalr);

  Vue.signalr = Socket;

  Object.defineProperty(Vue.prototype, '$signalr', {
    get() {
      return Socket;
    }
  });

  Object.defineProperty(Vue.prototype, '$eventSignalr', {
    get() {
      return eventSignalr;
    }
  });
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(plugin);
}
